import { BackspaceIcon, BackwardIcon, ClockIcon, CloudIcon, Cog8ToothIcon, XMarkIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getAllProduits } from '../store/produitSlice';
import { getAllPlats } from '../store/platSlice';
import { addVente } from '../store/venteSlice';
import { getCaisseRegisterBalance, getCaisseRegisterStatus } from '../store/settingsSlice';
import ModalForm from '../components/common/ModalForm';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Barcode from 'react-barcode';

function PosSystem() {
    const { produitList } = useSelector((state) => state.produit);
    const { platList } = useSelector((state) => state.plat);
    const { user } = useSelector((state) => state.auth);
    const { caisseStatus, caisseBalance } = useSelector((state) => state.settings);

    const [listePlats, setListePlats] = useState([]);
    const [listeProduits, setListeProduits] = useState([]);

    const dispatch = useDispatch();

    useEffect(() => {
        // Dispatch des actions une seule fois au montage
        dispatch(getAllProduits());
        dispatch(getAllPlats());
    }, [dispatch]);

    useEffect(() => {
        // Mettre à jour les états locaux lorsque les données changent
        setListeProduits(
            produitList.filter((produit) => produit.designation && produit.designation.startsWith("Produit"))
        );
        setListePlats(platList);
    }, [produitList, platList]);



    function formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    function formatDesignation(designation) {
        return designation.replace(/^Produit\s+/, "");
    }

    /*----------------------Validation du statut de la caisse--------------------------------------*/

    useEffect(() => {
        // Dispatch des actions une seule fois au montage
        dispatch(getCaisseRegisterBalance(user.id));
    }, [caisseBalance]);

    //console.log("caisseRegisterBalance POS ", caisseBalance);

    useEffect(() => {
        // Dispatch des actions une seule fois au montage
        dispatch(getCaisseRegisterStatus(user.id));
    }, [caisseStatus]);

    const getStatus = () => {
        // recupérer l'etat de la caisse dans le store        
        if (caisseStatus) {
            return true;
        } else {
            return false;
        }
    };
    //console.log("caisseStatus POS ", caisseStatus);

    /*----------------------Gestion du modal notification--------------------------------------*/
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState({});


    /*----------------------Logique de gestion du panier et de la quantité----------------------*/
    // Gestion du panier et de la quantité
    const [menus, setMenus] = useState([]);
    const [boissons, setBoissons] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const [taxes, setTaxes] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [isPayOpen, setIsPayOpen] = useState(false);
    const [isPayValid, setIsPayValid] = useState(true);
    const [payment, setPayment] = useState([]);
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [invoiceNumber, setInvoiceNumber] = useState(0);



    //ajout item to order / receipt
    function addToCart({ item, type }) {

        if (getStatus() === false) {
            setModalData(
                <>
                    <div className="">
                        <div className='flex flex-col items-center'>
                            <Cog8ToothIcon className="w-6 h-6 text-red-500" />
                            <h3 className="mt-2 font-semibold text-gray-900 text-lg">La caisse est fermée!</h3>
                            <p className="mt-1 text-gray-500 text-sm">
                                Veuillez ouvrir la caisse.
                            </p>
                            <p className="mt-1 text-gray-500 text-sm">
                                Ou contacter votre administrateur.
                            </p>
                        </div>
                        <XMarkIcon
                            onClick={() => setIsModalOpen(false)}
                            className="mt-5 w-10 h-10 text-orange-400 cursor-pointer place-self-center" />
                    </div>
                </>
            );
            return setIsModalOpen(true);
        }

        if (type === "Menu") {
            setMenus((prevMenus) => {
                // vérifier si l'item existe dans le panier
                const existingItem = prevMenus.findIndex((menu) => menu.id === item.id);

                if (existingItem !== -1) {
                    // si l'item existe, mettre à jour la quantité
                    const updatedMenus = [...prevMenus];
                    const existingMenu = updatedMenus[existingItem];
                    updatedMenus[existingItem] = {
                        ...existingMenu,
                        quantity: parseFloat(existingMenu.quantity + 1),
                        total: parseFloat(existingMenu.price) * (parseFloat(existingMenu.quantity + 1)),
                    }
                    return updatedMenus;
                }

                // si l'item n'existe pas dans le panier, on l'ajoute
                return [
                    ...prevMenus,
                    {// ajout de l'item sans écraser l'ancien
                        id: item.id,
                        designation: item.designation,
                        quantity: 1, // quantité initiale
                        price: parseFloat(item.prixVente),
                        total: parseFloat(item.prixVente),
                    },
                ];
            });

            //console.log(menus, "Menus");
            //update summary / receipt
            updateSummary();

        } else if (type === "Boisson") {
            setBoissons((prevBoissons) => {
                // verifier si l'item existe dans le panier
                const existingItem = prevBoissons.findIndex((boisson) => boisson.id === item.id);

                if (existingItem !== -1) {
                    // si l'item existe, mettre à jour la quantité
                    const updatedBoissons = [...prevBoissons];
                    const existingBoisson = updatedBoissons[existingItem];
                    updatedBoissons[existingItem] = {
                        ...existingBoisson,
                        quantity: parseFloat(existingBoisson.quantity) + 1,
                        total: parseFloat(existingBoisson.price) * (parseFloat(existingBoisson.quantity) + 1),
                    }
                    return updatedBoissons;
                }

                // si l'item n'existe pas dans le panier, on l'ajoute
                return [
                    ...prevBoissons,
                    {// ajout de l'item sans écraser l'ancien
                        id: item.id,
                        designation: item.designation,
                        quantity: 1, // quantité initiale
                        price: parseFloat(item.prixVente),
                        total: parseFloat(item.prixVente),
                    },
                ]
            });
        }
        //console.log(boissons, "Boissons");
        //console.log(menus, "Menus");
    }

    function generInvoiceNumber() {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const secondes = String(date.getSeconds()).padStart(2, '0');
        const invoiceNumber = `${year}${month}${day}${hours}${minutes}${secondes}`;
        setInvoiceNumber(invoiceNumber);
    }

    //suppression item from order / receipt
    function removeFromCart({ item, type }) {
        if (type === "Menu") {
            setMenus((prevMenus) => {
                // vérifier si l'item existe dans le panier
                const existingItem = prevMenus.findIndex((menu) => menu.id === item.id);

                if (existingItem !== -1) {
                    // si l'item existe et que la quantité est supérieure à 1, on diminue la quantité de 1
                    if (prevMenus[existingItem].quantity > 1) {
                        // si l'item existe, mettre à jour la quantité
                        const updatedMenus = [...prevMenus];
                        const existingMenu = updatedMenus[existingItem];
                        updatedMenus[existingItem] = {
                            ...existingMenu,
                            quantity: parseFloat(existingMenu.quantity - 1),
                            total: parseFloat(existingMenu.price) * (parseFloat(existingMenu.quantity) - 1),
                        }
                        return updatedMenus;

                    } else {
                        // si l'item existe et que la quantité est inferieur à 1, on supprime l'item
                        return prevMenus.filter((menu) => menu.id !== item.id);
                    }
                }
            });

            //console.log(menus, "Menus");

        } else if (type === "Boisson") {
            setBoissons((prevBoissons) => {
                // verifier si l'item existe dans le panier
                const existingItem = prevBoissons.findIndex((boisson) => boisson.id === item.id);

                if (existingItem !== -1) {
                    // si l'item existe et que la quantité est supérieure à 1, on diminue la quantité de 1
                    if (prevBoissons[existingItem].quantity > 1) {
                        // si l'item existe, mettre à jour la quantité
                        const updatedBoissons = [...prevBoissons];
                        const existingBoisson = updatedBoissons[existingItem];
                        updatedBoissons[existingItem] = {
                            ...existingBoisson,
                            quantity: parseFloat(existingBoisson.quantity) - 1,
                            total: parseFloat(existingBoisson.price) * (parseFloat(existingBoisson.quantity) - 1),
                        }
                        return updatedBoissons;

                    } else {
                        // si l'item existe et que la quantité est inferieur à 1, on supprime l'item
                        return prevBoissons.filter((boisson) => boisson.id !== item.id);
                    }
                }
            });
        }

        //console.log(boissons, "Boissons");
        //console.log(menus, "Menus");
    }

    //update summary / receipt
    function updateSummary() {
        // Calculer les totaux pour les menus et les boissons
        const totalMenus = menus.reduce((total, menu) => parseFloat(total) + parseFloat(menu.total), 0);
        const totalBoissons = boissons.reduce((total, boisson) => parseFloat(total) + parseFloat(boisson.total), 0);

        // Calculer le sous-total
        const calculatedSubtotal = parseFloat(totalMenus) + parseFloat(totalBoissons);
        setSubtotal(calculatedSubtotal.toFixed(2));

        // Calculer le total global en fonction des taxes
        const calculatedGrandTotal = taxes > 0
            ? calculatedSubtotal + (calculatedSubtotal * taxes / 100)
            : calculatedSubtotal;

        if (menus.length === 0 && boissons.length === 0) {
            setIsPayOpen(false);
        }

        setGrandTotal(calculatedGrandTotal.toFixed(2));
    }

    function toggleSettings() {
        // Mettre à jour caisseBalance
        dispatch(getCaisseRegisterStatus(user.id));
        getStatus();
        dispatch(getCaisseRegisterBalance(user.id));
        setIsSettingsOpen(!isSettingsOpen);
    }

    //Clear order 
    function clearOrder() {
        setMenus([]);
        setBoissons([]);
        setSubtotal(0);
        setGrandTotal(0);
        setTaxes(0);
        setPayment({ type: "", changeTip: 0, amount: 0 });
    }

    // Open paypad window
    function openPayPad(type) {
        if (type === "cash") {
            document.getElementById("tip-change-title").textContent = "Change: ";
            setPayment((prevPaiement) => ({
                ...prevPaiement,
                type: "Cash",
            }));
        } else if (type === "credit") {
            document.getElementById("tip-change-title").textContent = "Pourboire: ";
            closeSale(true);
            setPayment((prevPaiement) => ({
                ...prevPaiement,
                montant: parseFloat(grandTotal), // Remettre au format XX.00
                changeTip: parseFloat(0),  // Toujours >= 0
                type: "CC",
            }));
        } else {
            document.getElementById("tip-change-title").textContent = "Change: ";
            setPayment((prevPaiement) => ({
                ...prevPaiement,
                type: "",
            }));
        }
        setIsPayOpen(true);
    }

    function roundToTwo(num) {
        return Math.round(num * 100) / 100;
    }

    // Entrer le montant de la transaction avec le clavier
    function changePayment(input) {

        if (!isNaN(parseFloat(input))) {
            numberPaypad(parseFloat(input));
            console.log(input);
        } else if (input === "back") {
            backPaypad();
            console.log(input);
        } else if (input === "clear") {
            clearPaypad();
        } else {
            setIsPayValid(true);
        }
        /*
        // vérifier si le montant est suffisant
        if (montant !== null && montant !== "" && parseFloat(montant) < grandTotal) {
            const parsedMontant = parseFloat(montant);
            const changeTip = parsedMontant > grandTotal ? (parsedMontant - grandTotal).toFixed(2) : "0.00";

            setPayment((prevPaiement) => ({
                ...prevPaiement,
                montant: parsedMontant.toFixed(2), // Assurez-vous que le montant est bien formaté à 2 décimales                
                changeTip: changeTip, // Ajoutez le montant restant en tant que pourboire ou reste
            }));
            setIsPayValid(true);
        } else {
            alert("Montant insuffisant");
            // desactiver le bouton
            setIsPayValid(false);
            document.getElementById("paypad-close").disabled = false;
        }*/
    }

    // convertir le input en montant 
    function numberPaypad(input) {
        const currentInput = roundToTwo(input * 0.01); // Convertir l'input en centimes
        const currentAmountPaid = payment.montant ? roundToTwo(payment.montant) : 0; // Montant actuel
        const newAmountPaid = roundToTwo((currentAmountPaid * 10) + currentInput); // Nouveau montant

        const rawChangeTip = payment.type === "Cash" && newAmountPaid >= grandTotal ? newAmountPaid - grandTotal : 0.00;
        const changeTips = rawChangeTip > 0 ? rawChangeTip : 0.00; // Empêche les valeurs négatives

        newAmountPaid >= grandTotal ? closeSale(true) : closeSale(false);

        setPayment((prevPaiement) => {
            if (prevPaiement.type !== "Cash") {
                return {
                    ...prevPaiement,
                    montant: parseFloat(grandTotal), // Remettre au format XX.00
                    changeTip: parseFloat(0),  // Toujours >= 0
                };
            }
            // Vérifiez si prevPaiement existe et mettez à jour la propriété montant
            if (prevPaiement) {
                return {
                    ...prevPaiement,
                    montant: parseFloat(newAmountPaid), // Formaté à 2 décimales
                    changeTip: parseFloat(changeTips),  // Toujours >= 0
                };
            }

            // Si prevPaiement n'existe pas, retournez un nouvel objet
            return {
                montant: newAmountPaid.toFixed(2),
            };
        });

        checkPayment();

        console.log(payment, "payment");
        console.log(newAmountPaid, "newAmountPaid");

    }

    // back to previous paiement
    function backPaypad() {
        setPayment((prevPaiement) => {
            if (prevPaiement.type !== "Cash") {
                return {
                    ...prevPaiement,
                    montant: parseFloat(grandTotal), // Remettre au format XX.00
                    changeTip: parseFloat(0),  // Toujours >= 0
                };
            }
            if (prevPaiement && prevPaiement.montant) {
                const currentAmountPaid = parseFloat(prevPaiement.montant); // Convertir en nombre
                const newAmountPaid = Math.floor(currentAmountPaid * 10) / 100; // Supprimer le dernier chiffre

                // Calcul du changeTip uniquement si le type de paiement est en Cash
                const rawChangeTip = payment.type === "Cash" && newAmountPaid >= grandTotal ? newAmountPaid - grandTotal : 0.00;
                const changeTips = rawChangeTip > 0 ? rawChangeTip : 0.00; // Empêche les valeurs négatives

                newAmountPaid >= grandTotal ? closeSale(true) : closeSale(false);

                return {
                    ...prevPaiement,
                    montant: parseFloat(newAmountPaid), // Remettre au format XX.00
                    changeTip: parseFloat(changeTips),  // Toujours >= 0
                };
            }

            // Si aucun montant n'est défini, on ne fait rien
            return prevPaiement;
        });

        //setIsPayOpen(false);

        checkPayment();

        console.log(payment, "payment");
    }

    // Double check payement 
    function checkPayment() {
        setPayment((prevPaiement) => {

            const currentAmountPaid = parseFloat(prevPaiement.montant); // Convertir en nombre

            // Calcul du changeTip uniquement si le type de paiement est en Cash
            const rawChangeTip = payment.type === "Cash" && currentAmountPaid > grandTotal ? currentAmountPaid - grandTotal : 0.00;
            const changeTips = rawChangeTip > 0 ? rawChangeTip : 0.00; // Empêche les valeurs négatives

            return {
                ...prevPaiement,
                montant: parseFloat(currentAmountPaid), // Remettre au format XX.00
                changeTip: parseFloat(changeTips),  // Toujours >= 0
            };

        });

        return payment;
    }

    function closeSale(status) {
        if (status) {
            document.getElementById("close-sale").style.display = "block";
            document.getElementById("payment-overlay").style.height = "530px";
        } else {
            document.getElementById("close-sale").style.display = "none";
            document.getElementById("payment-overlay").style.height = "420px";
        }
    }
    // clear paypad
    function clearPaypad() {
        setPayment((prevPaiement) => {
            return {
                ...prevPaiement,
                montant: parseFloat(0),
                changeTip: parseFloat(0),
            }
        });

        closeSale(false);

        checkPayment();
    }

    useEffect(() => {
        // Mettre à jour les états locaux lorsque les données changent
        updateSummary();
        if (isSettingsOpen) {
            document.getElementById("sideBar").style.display = "block"
        } else {
            document.getElementById("navbar").style.display = "none";
            document.getElementById("sideBar").style.display = "none"
        }
        document.getElementById("wrapper").style.height = "auto";
        generInvoiceNumber();
    }, [menus, boissons, payment, isSettingsOpen, invoiceNumber, grandTotal]);

    //input payment button

    // close sale and save/send data to server
    function submitSale(e) {
        e.preventDefault();

        const venteData = {
            date: new Date(),
            numFacture: invoiceNumber,
            venteUserId: user.id,
            total: parseFloat(subtotal),
            taxe: parseFloat(taxes),
            grandTotal: parseFloat(grandTotal),
            montantPaye: parseFloat(payment.montant),
            changeTip: parseFloat(payment.changeTip),
            paiementType: payment.type,
            LgVentPlats: menus,
            LgVentProduits: boissons,
            businessid: user.businessid,
        };

        //dispatch(addVente(venteData));

        //console.log(venteData, "venteData");

        printReceipt();
        /*
                clearOrder();
                clearPaypad();
                setIsPayOpen(false);
                // Mettre à jour caisseBalance
                setIsSettingsOpen(false);*/
    }

    /*-------- PRINT RECEIPT --------*/
    const printRef = useRef(null);

    const printReceipt = async () => {
        const printContents = printRef.current;

        if (!printContents) return;

        const canvas = await html2canvas(printContents, {
            scale: 2, // Augmente la résolution de l'image
            useCORS: true, // Gère les ressources externes comme les images ou polices
            allowTaint: true,
            scrollX: 0,
            scrollY: 0,
        });

        // Convertir  canvas en image et stocker dans imgData
        const imgData = canvas.toDataURL('image/png');

        // Créer un nouveau document PDF
        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "px",
            format: "a4",
        });

        const pdfWidth = pdf.internal.pageSize.getWidth() - 20; // 20 pour les marges
        const pdfHeight = ((canvas.height * pdfWidth) / canvas.width) - 120;

        console.log(pdfWidth, "pdfWidth");

        // Ajouter l'image au document PDF
        pdf.addImage(imgData, 'PNG', 10, 10, pdfWidth, pdfHeight);

        // Enregistrer le document PDF    
        pdf.save('Reçu' + invoiceNumber + '.pdf');


    }

    return (
        <div className='bg-gray-800 p-3 rounded-md'>
            {/* Wrapper */}
            <div className='flex justify-between items-center'>
                <h1 className='mb-2 w-full font-bold text-2xl text-center text-gray-200'>MEZA NGEMA CAISSE</h1>
                <Cog8ToothIcon
                    onClick={() => toggleSettings()}
                    className='mt-[-30px] w-5 font-bold text-2xl text-center text-gray-200 cursor-pointer' />
            </div>
            <div className="flex sm:flex-row md:flex-col flex-1 main-container">
                {/* Receipt Section */}
                <section className="border-gray-300 col-span-2 p-2 border min-w-80 order" >

                    <div
                        ref={printRef}
                        className='border-gray-500 border-x-2 border-y-2 mb-1 p-2 border rounded'>
                        {/* Company Info */}
                        <div className='flex sm:flex-row md:flex-col flex-1 gap-8 mb-5 px-7'>
                            <div className="text-center">
                                <p className="font-bold text-lg">MEZA NGEMA</p>
                                <p>Rue Badjanani</p>
                                <p>Moroni - Ngazidja</p>
                                <p>269-453-5684</p>
                                <p id="invoice-number">N° #{invoiceNumber}</p>
                            </div>
                            <div className='mt-2 ml-5'>
                                <img
                                    className="mx-auto w-24 h-24"
                                    src="/assets/img/logo.png"
                                    alt="" />
                            </div>

                        </div>


                        {/* Receipt Details */}
                        <div className="mb-4 receipt-details">
                            <table className="border-collapse w-full text-sm details-detail">
                                <thead className="title">
                                    <tr >
                                        <td className="dotted-border" colSpan="5"></td>
                                    </tr>
                                    <tr >
                                        <th className="text-left dscription">Désignation</th>
                                        <th className="text-right quantity">Qte</th>
                                        <th className="text-right price">Prix</th>
                                        <th className="text-right subtotal">S-total</th>
                                        <th className="text-right delete"></th>
                                    </tr>
                                    <tr>
                                        <td className="dotted-border" colSpan="5"></td>
                                    </tr>
                                </thead>
                                <tbody id="receipt-details">
                                    {/* Dynamic rows go here */}

                                    {/* Menu */}
                                    {menus && menus.map((menu) => (
                                        <tr key={menu.id || menu.designation}>
                                            <td className="description">{menu.designation}</td>
                                            <td className="text-right quantity">{menu.quantity}</td>
                                            <td className="text-right price">{parseFloat(menu.price).toFixed(2)}</td>
                                            <td className="text-right subtotal">{formatPrice((menu.total).toFixed(2))}</td>
                                            <td className="delete">
                                                <BackspaceIcon
                                                    onClick={() => removeFromCart({ item: menu, type: "Menu" })}
                                                    className="w-5 h-5 text-gray-50 hover:text-gray-950 cursor-pointer"
                                                />
                                            </td>
                                        </tr>
                                    ))}

                                    {/* Séparateur des menu et des boissons */}
                                    <tr>
                                        <td className="dotted-border-separator" colSpan="5"></td>
                                    </tr>
                                    {/* End Séparateur des menu et des boissons */}

                                    {/* Boissons */}
                                    {boissons && boissons.map((boisson) => (
                                        <tr key={boisson.id || boisson.designation}>
                                            <td className="description">{boisson.designation}</td>
                                            <td className="text-right quantity">{boisson.quantity}</td>
                                            <td className="text-right price">{parseFloat(boisson.price).toFixed(2)}</td>
                                            <td className="text-right subtotal">{formatPrice((boisson.total).toFixed(2))}</td>
                                            <td className="text-end delete">
                                                <BackspaceIcon
                                                    onClick={() => removeFromCart({ item: boisson, type: "Boisson" })}
                                                    className="w-5 h-5 text-gray-50 hover:text-gray-950 cursor-pointer"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Receipt Summary */}
                        <div className="receipt-summary text-sm">
                            <table className="w-full summary-table">
                                <tbody className='summary-table' id="total-summary">
                                    <tr>
                                        <td className="dotted-border" colSpan="5"></td>
                                    </tr>
                                    <tr>
                                        <td>Total :</td>
                                        <td className="text-right subtotal-summary">{formatPrice(subtotal) || 0.00}</td>
                                        <td className='hover:bg-teal-200'></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>Taxe :</td>
                                        <td className="text-right subtotal-tax">{formatPrice(subtotal * taxes / 100) || 0.00}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td className="font-bold">Grand Total :</td>
                                        <td className="text-right font-bold subtotal-grand-total">{formatPrice(grandTotal) || 0.00}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <tbody className="summary-table" id="payment-summary">
                                    <tr>
                                        <td
                                            className={`${payment.montant < grandTotal ? 'text-red-600' : 'text-teal-500 font-semibold'}`}
                                        >Montant payé :</td>
                                        <td id="amount-paid"
                                            className={`${payment.montant < grandTotal ? 'text-red-600' : 'text-teal-500 font-semibold'}`}
                                        >{payment.montant ? formatPrice(payment.montant.toFixed(2)) : 0.00}</td>
                                    </tr>
                                    <tr>
                                        <td id="tip-change-title"
                                            className={`${payment.changeTip > 0 ? 'text-red-500 font-bold' : ''}`}
                                        >Change :</td>
                                        <td id="tip-change-value"
                                            className={`${payment.changeTip > 0 ? 'text-red-500 font-bold' : ''}`}
                                        >{payment.changeTip ? formatPrice(payment.changeTip.toFixed(2)) : 0.00}</td>
                                    </tr>
                                    <tr>
                                        <td>Type de paiement :</td>
                                        <td id="payment-type">{payment.type}</td>
                                    </tr>
                                    <tr>
                                        <td className="dotted-border" colSpan="5"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Footer */}
                        <div className="flex-row items-justify-center receipt-footer pb-1 text-center">
                            <p className='pb-2 text-md'>Merci pour votre commande</p>
                            <div className='place-items-center'>
                                <Barcode
                                    value={String(invoiceNumber)}
                                    displayValue={false}
                                    format="CODE128"
                                    width={1.8}
                                    height={28}
                                />
                            </div>

                        </div>
                    </div>
                    <div className="flex justify-between items-center border-gray-500 border-x-2 border-y-2 px-5 py-3 border rounded">
                        <i onClick={() => openPayPad('cash')}
                            className="fa-2x fa-money-bill-wave fas paypad-show toolbar-icon"></i>

                        <i onClick={() => openPayPad("credit")}
                            className="fa-2x fa-credit-card fas paypad-show toolbar-icon"></i>

                        <i className="fa-trash-alt fa-2x fas toolbar-icon" onClick={() => {
                            clearOrder()
                            clearPaypad()
                        }} id="clear-order"></i>
                    </div>
                </section>

                {/* Menu and Payment Section */}
                <section className="grid px-4 menu-payment">
                    {/* Menu Grid */}
                    <div className="flex pb-4 menu" id="menu">
                        {/* Example Menu Items */}

                        {/* Liste des plats */}
                        <h1 className="px-2 py-3 w-full font-bold text-2xl text-gray-200">MENU</h1><br />
                        {listePlats && listePlats.map((plat) => (
                            <figure
                                key={plat.id}
                                onClick={() => addToCart({ item: plat, type: "Menu" })}
                                className="pb-2 rounded-t-full text-center menu-item">
                                <img src={plat.photo} alt={plat.designation} className="rounded-full w-36 h-auto menu-img place-self-center" />
                                <figcaption >{plat.designation}</figcaption>
                                <figcaption className="text-sm">{formatPrice(plat.prixVente)} Kmf</figcaption>
                            </figure>
                        ))}
                        {/* end Liste des plats */}

                        {/* Liste des produits */}
                        <h1 className="px-2 py-3 w-full font-bold text-2xl text-gray-200">BOISSON</h1><br />
                        {listeProduits && listeProduits.map((produit) => (
                            <figure
                                key={produit.id}
                                onClick={() => addToCart({ item: produit, type: "Boisson" })}
                                className="pb-2 rounded-b rounded-t-full text-center menu-item">
                                <img src={produit.photo} alt={produit.designation} className="rounded-full w-36 h-auto menu-img place-self-center" />
                                <figcaption className="mt-2">{formatDesignation(produit.designation)} </figcaption>
                                <figcaption className="text-sm">{formatPrice(produit.prixVente)} Kmf</figcaption>
                            </figure>
                        ))}
                        {/* end Liste des produits */}
                    </div>

                    {/* Payment Keypad */}
                    <div className={`${isPayOpen ? "grid" : "hidden"} mt-16 max-w-80 payment"`} id="payment-overlay">
                        <div className="grid paypad" id="paypad">
                            <button className="number paypad-btn" onClick={() => changePayment(7)}>7</button>
                            <button className="number paypad-btn" onClick={() => changePayment(8)}>8</button>
                            <button className="number paypad-btn" onClick={() => changePayment(9)}>9</button>
                            <button className="number paypad-btn" onClick={() => changePayment(4)}>4</button>
                            <button className="number paypad-btn" onClick={() => changePayment(5)}>5</button>
                            <button className="number paypad-btn" onClick={() => changePayment(6)}>6</button>
                            <button className="number paypad-btn" onClick={() => changePayment(1)}>1</button>
                            <button className="number paypad-btn" onClick={() => changePayment(2)}>2</button>
                            <button className="number paypad-btn" onClick={() => changePayment(3)}>3</button>
                            <button className="number paypad-btn" onClick={() => changePayment(0)}>0</button>
                            <button className="paypad-btn" onClick={() => changePayment("back")}><BackspaceIcon className='w-8 place-self-center' /></button>
                            <button className="paypad-btn" onClick={() => changePayment("clear")}><XMarkIcon className='w-8 place-self-center' /></button>
                            <button className="paypad-btn span3-col" id="close-sale" onClick={submitSale}>Valider la vente</button>
                        </div>
                        <div className="w-16 close-paypad">
                            <i className="close-icon fa-times fas paypad-close" onClick={() => {
                                if (isPayValid) setIsPayOpen(false);;
                            }} id="paypad-close"></i>
                        </div>
                    </div>
                </section>
            </div>
            <ModalForm
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false)
                }}
                children={
                    <div className="flex flex-col justify-center items-center">
                        {modalData}
                    </div>
                }
            />
        </div>
    );
}

export default PosSystem;
